<template>
  <v-sheet border class="pa-4 mt-1 mb-1 w-100 rounded-lg bg-card" max-width="370">
    <v-icon :icon="icon" class="mr-3"></v-icon>
    <label class="text-md-subtitle-2">{{content}}</label>
  </v-sheet>
</template>

<script>
import { mapState } from "vuex";
import { defineComponent } from 'vue';
export default defineComponent({
  props: {
    icon: String,
    content: String,
  },
  computed: {
    ...mapState({ $_darkMode: "darkMode" }),
  },
});
</script>

<style scoped lang="scss">

</style>
